import React, { useState } from 'react';

import { App, DatePicker, DatePickerProps } from 'antd';

import dayjs from 'dayjs';
import { DATETIME_CLIENT_FORMAT, DATETIME_SERVER_FORMAT } from 'internal-constants';
import { useGuestsLogs } from 'lib/providers/GuestsLogsContextProvider';
import { smoothLoading } from 'lib/smoothLoading';
import { exitGuestLog } from 'services/Guest.service';
import { Guest } from 'types/Guest.type';

type Props = {
    id: Guest.Log.Model['id'],
    enteredAt: Guest.Log.Model['entered_at'],
}

export function ExitGuestLogCell({ id, enteredAt }: Props) {
    const [isSending, setIsSending] = useState(false);

    const app = App.useApp();

    const { fetchGuestsLogs} = useGuestsLogs();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const minDate: DatePickerProps['minDate'] = dayjs(enteredAt, DATETIME_SERVER_FORMAT);

    const onOk: DatePickerProps['onOk'] = async (value) => {
        setIsSending(true);

        const response = await exitGuestLog(
            id,
            { exited_at: value.format(DATETIME_SERVER_FORMAT) }
        );

        await smoothLoading();

        setIsSending(false);

        app.notification.open(response);

        fetchGuestsLogs();
    };

    return (
        <DatePicker
            style={{ width: '100%' }}
            format={DATETIME_CLIENT_FORMAT}
            onOk={onOk}
            disabled={isSending}
            showTime
        />
    );
}
